import { Component, inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { AuthService } from '../../../services/auth.service';
import { TranslatePipe } from '@bdeo-motor/angular-i18n';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  imports: [MatDialogContent, MatDialogActions, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LogOutDialog {
  private readonly authService = inject(AuthService);
  private readonly dialogRef = inject(MatDialogRef);

  public loading = false;

  onClose(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.authService.logOut();
    this.loading = true;
    setTimeout(() => {
      this.dialogRef.close(true);
    }, 1000);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
